import React, { useEffect, useRef, useState } from "react";

import { Helmet } from "react-helmet";

import DateFormat from "../../components/dateFormater";
import { _Classes } from "../../lib/styles";
import Button from "../../components/form/button";

export default function Clock() {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setNow(new Date());
        }, 1000);

        return function cleanUp() {
            clearInterval(timer);
        };
    }, []);
    function addLeadingZero(number: number): string {
        if (number >= 10) return number.toString();
        else return "0".concat(number.toString());
    }

    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Clock</title>
            </Helmet>
            <div className={`relative flex h-[92vh] w-full flex-col items-center justify-center gap-1`}>
                <div className="font-outline-4 font-mono text-7xl font-black lg:text-8xl xl:text-9xl">
                    {addLeadingZero(now.getHours())}:{addLeadingZero(now.getMinutes())}:{addLeadingZero(now.getSeconds())}
                </div>
                <div className="text-xl font-bold uppercase">
                    <DateFormat date={now.toDateString()} format={"$WD$ $MM$ $d$"} />
                </div>
            </div>
        </>
    );
}
